import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Link from '../Global/Link';
import { Helmet } from 'react-helmet';

// ====

function toggleMenu(status) {
  if (status === false) {
    // Do something
  } else if (status === true) {
    // Do something else
  }
}

const Header = (props) => {
  const { settings } = props;
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);
  useEffect(() => {
    toggleMenu(menuOpen);
  });

  // Site has the pages in it!
  return (
    <>
      {menuOpen === true && (
        <Helmet>
          <body className="brand-body-menu-open" />
        </Helmet>
      )}
      <header>
        <nav className="brand-navbar">
          <a className="brand-logo" href="/">
            {settings.name}
          </a>

          {settings.navigation && (
            <>
              <div
                className={`brand-menu ${
                  menuOpen === true && 'brand-menu-open'
                }`}
                id="brandMenu"
                ref={navRef}
                onClick={() => setMenuOpen(!menuOpen)}
                role="navigation"
              >
                <div className="brand-menu-items text-center">
                  {settings.navigation.map((node) => {
                    return (
                      <Link
                        to={`/${node.link.cached_url}`}
                        className="nav-item nav-link"
                        activeClassName="active"
                        partiallyActive={
                          node.link.cached_url === '' ? false : true
                        }
                        onClick={() => setMenuOpen(!menuOpen)}
                        key={node._uid}
                      >
                        {node.name}
                      </Link>
                    );
                  })}
                </div>
              </div>
              <button
                className={`brand-menu-trigger brand-desktop-hidden hamburger hamburger--spin ${
                  menuOpen === true ? `is-active` : ``
                }`}
                type="button"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                <span className="hamburger-box">
                  <span className="hamburger-inner" />
                </span>
              </button>
            </>
          )}
        </nav>
      </header>
    </>
  );
};

export default Header;

// ====

Header.propTypes = {
  settings: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Header.defaultProps = {
  settings: null,
};
